import { render, staticRenderFns } from "./SignupSectionUsers.vue?vue&type=template&id=6b1aca61"
import script from "./SignupSectionUsers.vue?vue&type=script&lang=js"
export * from "./SignupSectionUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports